<template>
  <div class="client-container">
    <div :style="{ overflow: 'hidden' }">
      <bread-crumb :style="{ float: 'left' }" />
      <a-button
        type="primary"
        shape="round"
        icon="plus"
        :style="{ float: 'right', marginTop: '19px' }"
        @click="editAndAdd"
      >
        新增协议模板
      </a-button>
      <a-button
        type="primary"
        shape="round"
        :style="{ float: 'right', marginTop: '19px',marginRight:'20px' }"
        @click="handleCurrent"
      >
        选择当前协议
      </a-button>
    </div>
    <div class="global-table-container">
      <a-table
        :columns="columns"
        :data-source="data"
        :loading="loading"
        :row-key="record => record.id"
        :pagination="{
          pageSize,
          total,
          current,
          showTotal: total => `共${total}条`,
        }"
        @change="changePage"
      >
        <template
          slot="pdf_doc_info"
          slot-scope="text,record"
        >
          <a
            :href="record.pdf_doc_info[0].url"
          >{{ record.pdf_doc_info[0].name }}</a>
        </template>
        <template
          slot="operation"
          slot-scope="text, record"
        >
          <a
            href="javascript:;"
            @click="() => editAndAdd(record)"
          >编辑</a>
          <a-divider type="vertical" />
          <popconfirm-button
            :text="record.status===1?'禁用':'启用'"
            :alert-title="record.status===1?'确定禁用？':'确定启用？'"
            @onDelete="() => onConfirm(record)"
          />
          <a-divider type="vertical" />
          <popconfirm-button
            text="删除"
            alert-title="确定删除？"
            @onDelete="() => onDelete(record)"
          />
        </template>
      </a-table>
    </div>
    <account-modal
      ref="formRef"
      :btn-is-loading="btnIsLoading"
      :activity-visible="activityVisible"
      :title="title"
      @onCancel="onCancel"
      @handleSubmit="handleSubmit"
    />
    <current-agreement
      ref="currentRef"
      :btn-is-loading="btnIsLoading"
      :visible="currentVisible"
      @onCancel="onCancelCurrent"
      @handleSubmit="handleSubmitCurrent"
    />
  </div>
</template>
<script>
import { columns } from './data/index';
import AccountModal from './modal/index';
import CurrentAgreement from './modal/currentAgreement';
export default {
  components: { AccountModal, CurrentAgreement },
  data() {
    return {
      btnIsLoading: false,
      selectData: [],
      columns,
      data: [],
      pageSize: 10,
      current: 1,
      total: 0,
      loading: false,
      activityVisible: false,
      title: '',
      id: '',
      currentVisible: false,
    };
  },
  mounted() {
    // 获取表格数据
    this.getTableData({
      page: String(this.current),
      pageSize: String(this.pageSize),
    });
  },
  methods: {
    // 获取表格数据
    async getTableData(params) {
      this.loading = true;
      let result = await this.$http.post(
        '/AgreementDoc/getList',
        params,
      );
      if (result.data.status === 1) {
        this.loading = false;
        this.total = result.data.data.count;
        this.current = Number(params.page);
        let data = result.data.data.data_list;
        let temp = [];
        data.forEach((item) => {
          let obj = {
            id: item.id,
            status: item.status,
            current: item.current,
            title: item.title,
            title_sub: item.title_sub,
            summary: item.summary,
            pdf_doc_info: item.pdf_doc_info,
            data: item,
          };
          temp.push(obj);
        });
        this.data = temp;
      }
    },
    // // 新增 编辑
    editAndAdd(record) {
      console.log('TCL: editAndAdd -> record', record);
      this.activityVisible=true;
      if (!record.id) {
        this.title = '新增协议模板';
        this.$nextTick(() => {
          this.$refs.formRef.$refs.basicForm.form.resetFields();
        });
      } else {
        this.id=record.id;
        this.title = '编辑协议模板';
        let data={
          title: record.title,
          title_sub: record.title_sub,
          pdf_doc_info: [{
            uid: record.pdf_doc_info[0].id,
            name: record.pdf_doc_info[0].name,
            url: record.pdf_doc_info[0].url,
            status: 'done',
          }],
          summary: record.summary,
          pdf_params: record.data.pdf_params,
          sort: record.data.sort,
        };
        console.log('data', data);
        this.$nextTick(() => {
          this.$refs.formRef.$refs.basicForm.form.setFieldsValue(data);
        });
      }
    },
    // 确认新增
    handleSubmit() {
      this.$refs.formRef.$refs.basicForm.form.validateFields(
        async(err, values) => {
          if (!err) {
            this.btnIsLoading=true;
            values.pdf=values.pdf_doc_info[0].uid;
            values.id=this.id?this.id:undefined;
            let result = await this.$http.post(
              '/AgreementDoc/update',
              values,
            );
            this.btnIsLoading=false;
            if (result.data.status === 1) {
              this.$message.success('操作成功！');
              this.activityVisible = false;
              this.getTableData({
                page: this.current,
                pageSize: this.pageSize,
              });
            }
          }
        },
      );
    },
    // 取消新增
    onCancel() {
      this.activityVisible = false;
    },
    // 选择当前使用协议
    handleCurrent(){
      this.currentVisible=true;
      this.$nextTick(()=>{
        this.$refs.currentRef.$refs.basicForm.form.resetFields();
      });
    },
    // 取消选择当前使用协议
    onCancelCurrent(){
      this.currentVisible=false;
    },

    // 提交当前使用
    async handleSubmitCurrent(){
      this.$refs.currentRef.$refs.basicForm.form.validateFields(
        async(err, values) => {
          if (!err) {
            this.btnIsLoading=true;
            let result=await this.$http.post('/AgreementDoc/setCurrent', {id: values.id, current: 1});
            this.btnIsLoading=false;
            if(result.data.status===1){
              this.currentVisible=false;
              this.$message.success('操作成功！');
              this.getTableData({ page: this.current, pageSize: this.pageSize });
            }
          }
        });
    },
    // 禁用 启用
    async onConfirm(record) {
      let result=await this.$http.post('/AgreementDoc/setStatus', {id: record.id, status: record.status===1?0:1});
      if(result.data.status===1){
        this.$message.success('操作成功！');
        this.getTableData({ page: this.current, pageSize: this.pageSize });
      }
    },
    // 删除
    async onDelete(record) {
      let result=await this.$http.post('/AgreementDoc/setStatus', {id: record.id, status: -1});
      if(result.data.status===1){
        this.$message.success('操作成功！');
        this.getTableData({ page: this.current, pageSize: this.pageSize });
      }
    },
    // 分页
    changePage(pagination) {
      this.current=pagination.current;
      this.getTableData({
        page: String(pagination.current),
        pageSize: String(pagination.pageSize),
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.client-container {
}
</style>
